import {
    DESIGNER_VERSION,
    DesignerVersion,
    IDesignStateSnapshot
} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {migration_0_1} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/0->1-migration';
import {migration_1_2} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/1->2-migration';
import {migration_10_11} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/10->11-migration';
import {migration_11_12} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/11->12-migration';
import {migration_12_13} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/12->13-migration';
import {migration_13_14} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/13->14-migration';
import {migration_14_15} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/14->15-migration';
import {migration_15_16} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/15->16-migration';
import {migration_16_17} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/16->17-migration';
import {migration_17_18} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/17->18-migration';
import {migration_18_19} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/18->19-migration';
import {migration_19_20} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/19->20-migration';
import {migration_2_3} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/2->3-migration';
import {migration_20_21} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/20->21-migration';
import {migration_21_22} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/21->22-migration';
import {migration_22_23} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/22->23-migration';
import {migration_23_24} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/23->24-migration';
import {migration_24_25} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/24->25-migration';
import {migration_25_26} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/25->26-migration';
import {migration_26_27} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/26->27-migration';
import {migration_27_28} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/27->28-migration';
import {migration_28_29} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/28->29-migration';
import {migration_29_30} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/29->30-migration';
import {migration_3_4} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/3->4-migration';
import {migration_30_31} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/30->31-migration';
import {migration_31_32} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/31->32-migration';
import {migration_32_33} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/32->33-migration';
import {migration_33_34} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/33->34-migration';
import {migration_34_35} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/34->35-migration';
import {migration_35_36} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/35->36-migration';
import {migration_36_37} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/36->37-migration';
import {migration_37_38} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/37->38-migration';
import {migration_38_39} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/38->39-migration';
import {migration_39_40} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/39->40-migration';
import {migration_4_5} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/4->5-migration';
import {migration_40_41} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/40->41-migration';
import {migration_41_42} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/41->42-migration';
import {migration_42_43} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/42->43-migration';
import {migration_43_44} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/43->44-migration';
import {migration_44_45} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/44->45-migration';
import {migration_45_46} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/45->46-migration';
import {migration_46_47} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/46->47-migration';
import {migration_47_48} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/47->48-migration';
import {migration_48_49} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/48->49-migration';
import {migration_49_50} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/49->50-migration';
import {migration_5_6} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/5->6-migration';
import {migration_50_51} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/50->51-migration';
import {migration_51_52} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/51->52-migration';
import {migration_52_53} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/52->53-migration';
import {migration_53_54} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/53->54-migration';
import {migration_54_55} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/54->55-migration';
import {migration_55_56} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/55->56-migration';
import {migration_56_57} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/56->57-migration';
import {migration_57_58} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/57->58-migration';
import {migration_58_59} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/58->59-migration';
import {migration_59_60} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/59->60-migration';
import {migration_6_7} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/6->7-migration';
import {migration_60_61} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/60->61-migration';
import {migration_61_62} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/61->62-migration';
import {migration_62_63} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/62->63-migration';
import {migration_7_8} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/7->8-migration';
import {migration_8_9} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/8->9-migration';
import {migration_9_10} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/9->10-migration';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import bind from 'bind-decorator';

export interface IMigration
{
    readonly from:DesignerVersion;
    readonly to:DesignerVersion;
    readonly migrate:(designState:any) => any;
}

const migrations:Array<IMigration> = [
    migration_0_1,
    migration_1_2,
    migration_2_3,
    migration_3_4,
    migration_4_5,
    migration_5_6,
    migration_6_7,
    migration_7_8,
    migration_8_9,
    migration_9_10,
    migration_10_11,
    migration_11_12,
    migration_12_13,
    migration_13_14,
    migration_14_15,
    migration_15_16,
    migration_16_17,
    migration_17_18,
    migration_18_19,
    migration_19_20,
    migration_20_21,
    migration_21_22,
    migration_22_23,
    migration_23_24,
    migration_24_25,
    migration_25_26,
    migration_26_27,
    migration_27_28,
    migration_28_29,
    migration_29_30,
    migration_30_31,
    migration_31_32,
    migration_32_33,
    migration_33_34,
    migration_34_35,
    migration_35_36,
    migration_36_37,
    migration_37_38,
    migration_38_39,
    migration_39_40,
    migration_40_41,
    migration_41_42,
    migration_42_43,
    migration_43_44,
    migration_44_45,
    migration_45_46,
    migration_46_47,
    migration_47_48,
    migration_48_49,
    migration_49_50,
    migration_50_51,
    migration_51_52,
    migration_52_53,
    migration_53_54,
    migration_54_55,
    migration_55_56,
    migration_56_57,
    migration_57_58,
    migration_58_59,
    migration_59_60,
    migration_60_61,
    migration_61_62,
    migration_62_63,
];

function validateMigrations()
{
    for( let i = 0; i < DESIGNER_VERSION; i++ )
    {
        const migration:IMigration = migrations[i];

        Assert.yes(migration.from === i, 'Invalid Migrations List');
    }

    Assert.yes(migrations.length === DESIGNER_VERSION, `DESIGNER_VERSION:${DESIGNER_VERSION} do not match to migrations list`);
}

validateMigrations();

export class DesignMigrationController
{
    @bind
    public migrateDesign(designSnapshot:IDesignStateSnapshot):boolean
    {
        let isDesignMigrated:boolean = false;

        const designerVersion:number = designSnapshot.designerVersion || 0;

        Assert.yes(designerVersion >= 0 && designerVersion <= DESIGNER_VERSION, `Invalid DesignerVersion:${designSnapshot.designerVersion} in saved design`);

        for( let i = designerVersion; i < DESIGNER_VERSION; i++ )
        {
            const migration:IMigration = migrations[i];

            designSnapshot = migration.migrate(designSnapshot);

            isDesignMigrated = true;

            Assert.yes(
                designSnapshot.designerVersion === migration.to && designSnapshot.designerVersion === migration.from + 1,
                `designerVersion:${designSnapshot.designerVersion} do not match after migration`
            );
        }

        return isDesignMigrated;
    }
}
